import AdminResource from "./adminResource";
import AuditorResource from "./auditorResource";
import AuditResource from "./auditResource";
import AuthResource from "./authResource";
import CompanyResource from "./companyResource";
import ManagerResource from "./managerResource";
import UserResource from "./userResource";
import axios from "axios";
import {toast} from "react-toastify";

const http = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

http.interceptors.request.use((config) => {
    let user = localStorage.getItem('Gein[user]') ? JSON.parse(localStorage.getItem('Gein[user]')) : null;

    if (user && user.accessToken)
        config.headers.Authorization = `Bearer ${user.accessToken}`;

    return config;
}, (error) => {
    // Do something with request error
    return Promise.reject(error);
});

http.interceptors.response.use((response) => {
    // Do something with response data
    return response;
}, (error) => {
    if (error.response)
        error = error.response.data;

    let errorMsg = 'Ocorreu um erro';
    if (error[0] && error[0].field) {
        errorMsg = error.map(function (e) {
            return e.message;
        }).join('\n');
    } else if (error[0]) {
        errorMsg = error.join('\n');
    } else if (error.message) {
        errorMsg = error.message;
    }

    if (!toast.isActive(this.toastId)) {
        this.toastId = toast.error(errorMsg);
    }

    // Do something with response error
    return Promise.reject(error);
});

export default {
    adminResource: new AdminResource({http}),
    auditorResource: new AuditorResource({http}),
    auditResource: new AuditResource({http}),
    authResource: new AuthResource({http}),
    companyResource: new CompanyResource({http}),
    managerResource: new ManagerResource({http}),
    userResource: new UserResource({http}),
}




// WEBPACK FOOTER //
// ./src/resources/index.js